import React from 'react'

function VerticalProBarPending({ title, progress, levels }) {
    return (
        <div className="progress-bar-container" style={{ position: "relative" }}>
            <h5 className={`${title === "Difficulty" ? "titlecolorDiff" : "titlecolorSkill"}`}>{title}</h5>
            <div className="d-flex gap-1" style={{ marginRight: "80px" }}>
                <div className="progress-bar" style={{ margin: "0px 10px" }}>
                    <div
                        className="progress"
                        style={{
                            height: `${progress}%`,
                            background: title === "Difficulty" ? "#83cbeb" : "#84e291",
                            borderRadius: "unset"
                        }}
                    ></div>
                </div>
                <div className="progress-labels">
                    {levels.map((level, index) => (
                        <span key={index}>{level}</span>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default VerticalProBarPending